module.exports = __webpack_public_path__ + "static/media/print.3c476321.svg";